import React, { useEffect, useState } from "react";
import { TRAININGS } from "../../config/apiConfig";
import { Button, Pagination, Table } from "flowbite-react";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import moment from "moment";
import "moment-timezone";
import "moment/locale/pt-br";
import { FiEye } from "react-icons/fi";
import Drawer from "../Drawer";
import CompanySupportForm from "../forms/CompanySupportForm";
import FilterToolbar from "../inputs/FilterToolbar";
import { FaEdit, FaRegCheckCircle } from "react-icons/fa";
import { IoIosCloseCircleOutline, IoMdSearch } from "react-icons/io";
import CompanyDetailsForm from "../forms/CompanyDetailsForm";

moment.tz.setDefault("America/Sao_Paulo");
moment.locale("pt-br");

const TrainingsTable = () => {
  const [isVisibleFilter, setIsVisibleFilter] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isDrawerOpenCompanyDetails, setIsDrawerOpenCompanyDetails] =
    useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const onPageChange = (page) => setCurrentPage(page);

  const {
    isLoading: isLoadingTrainings,
    error,
    data: trainings,
  } = useQuery(["trainings", currentPage], async () => {
    const { data: items } = await axios.get(
      `${TRAININGS.LIST}?page=${currentPage}`
    );
    setTotalPages(items.totalPages || 1);
    setTotalCount(items.totalCount || 0);

    return items.data;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [nameParam]);

  const handleViewCompany = (company) => {
    setIsDrawerOpenCompanyDetails(true);
    setSelectedCompany(company);
  };

  const handleChangeCompany = (company) => {
    setIsDrawerOpen(true);
    setSelectedCompany(company);
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  return (
    <>
      <FilterToolbar
        isVisible={isVisibleFilter}
        setIsVisible={setIsVisibleFilter}
      >
        {/* <div className="flex gap-2">
          <div className="flex gap-2 flex-col md:flex-row w-full">
            <div className="flex items-center gap-2 w-full bg-gray-100 rounded-md pl-2 pr-0 py-1">
              <GoPersonFill className="color-secondary text-xl mt-1" />
              <select
                id="underline_select"
                className="mt-1 w-full md:w-40 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition focus:border-pink-500 focus:outline-none focus:ring-0"
                value={typeCustomer}
                onChange={({ target }) => setTypeCustomer(target.value)}
              >
                <option selected value={-1}>
                  Todos os clientes
                </option>
                <option value={1}>Clientes teste</option>
                <option value={0}>Clientes Ativos</option>
              </select>
            </div>
            <div className="flex items-center gap-2 w-full bg-gray-100 rounded-md pl-2 pr-0 py-1">
              <FcPlanner className="color-secondary text-xl mt-1" />
              <select
                id="underline_select"
                className="mt-1 w-full md:w-40 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition focus:border-pink-500 focus:outline-none focus:ring-0"
                value={expirationDate}
                onChange={({ target }) => setExpirationDate(target.value)}
              >
                <option selected value={0}>
                  Data de Expiração
                </option>
                <option value={1}>Não expirados</option>
                <option value={2}>Prestes a expirar</option>
                <option value={3}>Expirados</option>
              </select>
            </div>
          </div>
        </div> */}
      </FilterToolbar>
      <div className="mt-5 text-sm font-semibold">
        Total de {totalCount} treinamentos
      </div>
      <form
        className="flex gap-1 mt-2 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300 mb-4 md:mb-0"
        onSubmit={handleSearchName}
      >
        <input
          type="text"
          placeholder="Busque por nome, email ou telefone..."
          className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition placeholder:text-slate-400 focus:border-pink-500 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>
      <div className="overflow-x-auto shadow-lg rounded-lg mt-0 md:mt-5">
        <Table striped>
          {trainings?.length > 0 ? (
            <Table.Head>
              <Table.HeadCell className="text-center bg-gray-300">
                Nome
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300">
                Telefone
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300">
                Data do treinamento
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300">
                Horário do treinamento
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300">
                Treinamento realizado
              </Table.HeadCell>
            </Table.Head>
          ) : (
            <></>
          )}

          <Table.Body className="divide-y">
            {!isLoadingTrainings ? (
              <>
                {trainings.length > 0 && (
                  <>
                    {trainings.map((training, index) => (
                      <Table.Row
                        key={index}
                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                      >
                        <Table.Cell className="text-center">
                          {training.Customer?.name || "Não informado"}
                        </Table.Cell>
                        <Table.Cell className="text-center whitespace-nowrap">
                          {training.Customer?.phoneNumber || "Não informado"}
                        </Table.Cell>
                        <Table.Cell className="text-center whitespace-nowrap">
                          {moment(training.date).format("DD/MM/yyyy")}
                        </Table.Cell>
                        <Table.Cell className="text-center whitespace-nowrap">
                          {training.startHour}
                        </Table.Cell>
                        <Table.Cell className="text-center whitespace-nowrap flex justify-center">
                          {training.statusId !== 1 ? <IoIosCloseCircleOutline color="red" fontSize={25} /> : <FaRegCheckCircle color="green" fontSize={21} />}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </>
                )}
              </>
            ) : (
              <>
                {Array.from({ length: 12 }).map((_, index) => (
                  <Table.Row
                    key={index}
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                  >
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white text-center">
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                      </div>
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white text-center">
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                      </div>
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white text-center">
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                      </div>
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white text-center">
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                      </div>
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white text-center">
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </>
            )}
          </Table.Body>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="flex overflow-x-auto justify-center mt-3">
          <Pagination
            layout="pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel=""
            nextLabel=""
            showIcons
          />
        </div>
      )}

      <Drawer
        title={"Visualizar empresa"}
        onClose={setIsDrawerOpenCompanyDetails}
        isOpen={isDrawerOpenCompanyDetails}
        className="w-full md:w-3/6 pb-36"
      >
        <CompanyDetailsForm
          company={selectedCompany}
          onClose={setIsDrawerOpenCompanyDetails}
          isDrawerOpen={isDrawerOpenCompanyDetails}
        />
      </Drawer>

      <Drawer
        title={"Editar empresa"}
        onClose={setIsDrawerOpen}
        isOpen={isDrawerOpen}
        className="w-full md:w-3/6 pb-36"
      >
        <CompanySupportForm
          company={selectedCompany}
          onClose={setIsDrawerOpen}
          isDrawerOpen={isDrawerOpen}
          fetchCompanies={() =>
            queryClient.invalidateQueries(["companies", currentPage])
          }
          type="EDIT"
        />
      </Drawer>
    </>
  );
};

export default TrainingsTable;
